// extracted by mini-css-extract-plugin
module.exports = {"container":"About-module--container--7t9w9"};